import { useState } from 'react';
import moment from "moment";
import { Toggle, TextInput } from 'carbon-components-react';
import { PencilOff } from 'lucide-react';
import TrialIdModal from './TrialIdModal'
import './DetailOverview.scss';

const DetailOverview = ({
  data,
  submit,
}) => {
  const [idModalIsOpen, setIdModalIsOpen] = useState(false)

  const onlyAttachment = localStorage.getItem('only_attachment')
  const formatUpdateDate = (date) => {
    if (!data) return null;
    return date ? moment(date).format("DD-MMM-YYYY, hh:mm:ss a") : "N/A";
  }

  const onToggle = (value, id, evt) => {
    submit(id, value)
  }

  return (
    <div>
      <div className="detail-overview__grid">
        <div>
          <label className="detail-overview__field-label">Sponsor Trial ID</label>
          <div className="detail-overview__trial-id">
            <div className="detail-overview__trial-id-input">
              <TextInput
                id="org_study_id"
                labelText=""
                value={data?.org_study_id || "N/A"}
                size="sm"
                readOnly={true}
              />
            </div>
            {onlyAttachment !== "true" &&
              <button
                className="detail-overview__edit-btn"
                onClick={() => setIdModalIsOpen(true)}
              >Edit</button>
            }
          </div>
        </div>

        <div>
          <label className="detail-overview__field-label">Study Updated on</label>
          <div className="detail-overview__readonly-value">
            {formatUpdateDate(data?.updated_at)}
            <PencilOff />
          </div>
        </div>
      </div>

      <div className="detail-overview__toggles">
        <Toggle
          id="has_results"
          labelA="Does Not Have Results"
          labelB="Has Results"
          onToggle={onToggle}
          toggled={data?.has_results}
          disabled={true}
        />
        <Toggle
          id="published"
          labelA="Not Visible on Website"
          labelB="Visible on Website"
          onToggle={onToggle}
          toggled={data?.published}
        />
        {onlyAttachment !== "true" &&
          <Toggle
            id="featured"
            labelA="Not Featured on Home Page"
            labelB="Featured on Home Page"
            onToggle={onToggle}
            toggled={data?.featured}
          />
        }
      </div>

      <TrialIdModal
        open={idModalIsOpen}
        onClose={() => setIdModalIsOpen(false)}
        onConfirm={(val) => submit('org_study_id', val)}
        data={data}
      />
    </div>
  );
}

export default DetailOverview;
